import { CREATE_OBJECT_SUCCESS } from "./types"
import { CALL_API } from "middleware/api"

const createAccountContact = data => {
  const options = {}
  options.data = { account_contact: data }
  options.params = { include: "account,contact" }

  return {
    [CALL_API]: {
      endpoint: "/account_contacts",
      method: "post",
      options,
      successType: CREATE_OBJECT_SUCCESS,
    },
  }
}

const updateAccountContact = (accountContactId, data) => {
  const options = {}
  options.data = { account_contact: data }
  options.params = { include: "account,contact" }

  return {
    [CALL_API]: {
      endpoint: `/account_contacts/${accountContactId}`,
      method: "patch",
      options,
    },
  }
}

export { createAccountContact, updateAccountContact }
